/* eslint global-require: "off", import/no-dynamic-require: "off" */
import path from 'path';

const parserNames = [
  'vBulletin-3.8.0',
];

const parsers = {};

parserNames.forEach((name) => {
  parsers[name] = require(path.join(__dirname, name)).default;
});

export default parsers;
